import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PaymentCancelled.css'; // Optional: for styling

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="cancelled-container">
      <div className="cancelled-card">
        <div className="cancelled-x-mark">✗</div>
        <h1>Payment Cancelled</h1>
        <p>Your payment process was not completed, and you have not been charged. You can return to the homepage or try again from the pricing page.</p>
        <div className="cancelled-buttons">
          <button 
            className="button-secondary" 
            onClick={() => navigate('/')}
          >
            Go to Homepage
          </button>
          <button 
            className="button-primary" 
            onClick={() => navigate('/pricing')}
          >
            Back to Pricing
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
